// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__G9T5H","inner":"Footer_inner__19Ojj"};